// Check if a product's offer is currently active based on schedule window.
export const isOfferActive = (product) => {
  const dp = product?.discount_percent || 0;
  if (dp <= 0) return false;
  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  const starts = product?.offer_starts_at || "";
  const expires = product?.offer_expires_at || "";
  if (starts && today < starts) return false;
  if (expires && today > expires) return false;
  return true;
};
